import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-main-button',
  templateUrl: './main-button.component.html',
  styleUrls: ['./main-button.component.scss'],
  standalone: false
})
export class MainButtonComponent {
  @Input() customClass: string = '';
  @Input() label: string = 'loading-button.loadMore';
  /** Ícono opcional (nombre de Ionicons) antes del texto. */
  @Input() icon?: string;
  /** Parámetros de interpolación del label (ej. `{ total: '$ 12.000' }`). */
  @Input() loadingLabel: string = 'loading-button.loading';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() visible: boolean = true;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  @Output() clicked = new EventEmitter<void>();

  handleClick(): void {
    if (this.type !== 'submit') {
      this.clicked.emit();
    }
  }

}
